import React from 'react';

import Button from 'components/ContentfulFields/Button';
import { withContent } from 'components/Content';
import P from 'components/Ui/P';

import styles from './dispensers.scss';

const CONTENT_KEYS = {
  title: 'Title',
  description: 'Description',
  ctaBtn: 'CTA',
  images: 'Images',
};

const Dispensers = ({ content }) => {
  const { title, description, ctaBtn, images } = content;
  return (
    <section className={styles.dispensers}>
      <h2 className={styles.title}>{title}</h2>
      <P className={styles.description}>{description}</P>
      <Button className={styles.cta} document={ctaBtn} />
      <div className={styles.images}>
        {images.fields.images.map((item) => (
          <img
            key={item.sys.id}
            src={`${item.fields.file.url}?fm=webp`}
            alt={item.fields.title || ''}
            aria-hidden="true"
          />
        ))}
      </div>
    </section>
  );
};

export default withContent(CONTENT_KEYS)(Dispensers);
